import {faRefresh} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tag, Tooltip} from 'antd';

import {Locale} from '../../../../provider/locale/localization';
import {CatalogPostStatusEnum} from '../../../../service/posts/posts-types';

import {CATALOG_POST_STATUS_OPTIONS} from './post-status-const';
import * as styles from './post-status.scss';

type PropsType = {
    isRefreshing?: boolean;
    status: CatalogPostStatusEnum;
};

export function CatalogPostStatus(props: PropsType): JSX.Element {
    const {isRefreshing = false, status} = props;

    const postStatusOption = CATALOG_POST_STATUS_OPTIONS[status];

    return (
        <Tag color={postStatusOption.color}>
            <span className={styles.CatalogPostStatus_content}>
                <Locale stringKey={postStatusOption.name} />
                {isRefreshing ? (
                    <Tooltip title={<Locale stringKey="POST__DETAILS_TABLE__STATUS__REFRESHING_TOOLTIP" />}>
                        <FontAwesomeIcon icon={faRefresh} />
                    </Tooltip>
                ) : null}
            </span>
        </Tag>
    );
}
